import {
  CreateDocumentDto,
  DocumentCommonDto,
  DocumentPlaybookComplianceScore,
  GetDocumentDto,
  GetDocumentDtoExtended,
} from '../models/documents.model';

export interface DocumentPageReviewProgress {
  pageNumber: number;
  totalPages: number;
}

export interface DocumentsState {
  documents: GetDocumentDtoExtended[] | null;
  loadingDocuments: boolean;
  creatingDocument: boolean;
  closeCreatingDocumentModal: boolean;
  deletingDocument: boolean;
  document: GetDocumentDto | null;
  loadingDocument: boolean;
  uploadingDocumentData: CreateDocumentDto | null;
  uploadingDocumentVersionData: UploadingDocumentVersionData | null;
  selectedDocumentFileId: string | null;
  selectedDocumentFileUploadError: string | null;
  selectedDocumentFileUploadRequestKey: string | null;
  selectedDocumentFileUploading: boolean;
  editingDocument: boolean;
  closeEditingDocumentModal: boolean;
  sendingReport: boolean;
  sendingReportDocument: GetDocumentDto | null;
  askingReportStatus: boolean;
  closeSendingReportModal: boolean;
  activePageReviewDocumentUniqueId: string | null;
  pageReviewProgressByDocumentId: Record<string, DocumentPageReviewProgress>;
  pageReviewResponseDataByDocumentId: Record<string, DocumentPlaybookComplianceScore[]>;
  selectedPlaybookIdByDocumentId: Record<string, string | null>;
}

export interface UploadingDocumentVersionData {
  versionLabel: string;
  documentName: string;
  fileName: string;
}

export const initialState: DocumentsState = {
  documents: null,
  loadingDocuments: false,
  creatingDocument: false,
  closeCreatingDocumentModal: false,
  deletingDocument: false,
  document: null,
  loadingDocument: false,
  uploadingDocumentData: null,
  uploadingDocumentVersionData: null,
  selectedDocumentFileId: null,
  selectedDocumentFileUploadError: null,
  selectedDocumentFileUploadRequestKey: null,
  selectedDocumentFileUploading: false,
  editingDocument: false,
  closeEditingDocumentModal: false,
  sendingReport: false,
  sendingReportDocument: null,
  askingReportStatus: false,
  closeSendingReportModal: false,
  activePageReviewDocumentUniqueId: null,
  pageReviewProgressByDocumentId: {},
  pageReviewResponseDataByDocumentId: {},
  selectedPlaybookIdByDocumentId: {},
};
